<template>
  <div id="edit-blog">
    <h2>编辑博客</h2>
    <form action="" v-if="!submitted">
      <label for="">博客标题</label>
      <input type="text" v-model="blog.title" required>
      <label for="">博客内容</label>
      <textarea v-model="blog.content"></textarea>
    
  <!-- checkboxes --> 
    <div id ="checkboxes">    
      <input type="checkbox" value = "Vue.js" v-model="blog.categories">
      <label for="">Vue.js</label>
      <input type="checkbox" value = "React" v-model="blog.categories">
      <label for="">React</label>
      <input type="checkbox" value = "Angular" v-model="blog.categories">
      <label for="">Angular</label>
      <input type="checkbox" value = "Node.js" v-model="blog.categories">
      <label for="">Node.js</label>
    </div>
  <!-- 作者 -->
    <label for="">作者</label>
    <select name="" id="" v-model="blog.author">
      <option v-for="author in authors" :key="author">{{author}}</option>
    </select>
    <!-- 提交button -->
    <button @click.prevent="post">保存</button>
  </form>
   
   <!-- 显示博客发送成功在preview上面 -->
   <div v-if="submitted">
     <h3>博客发送成功</h3>
   </div>

<!-- preview -->
    <div id = "preview">
      <h3>博客总览</h3>
      <p>博客标题: {{blog.title}}</p>
      <p>博客内容</p>
      <p>{{blog.content}}</p>
      <p>博客分类</p>
      <ul>
        <li v-for="category in blog.categories" :key="category">
          {{category}}
        </li>
      </ul>
      <p>作者：{{blog.author}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'edit-blog',
  data () {
    return {
      id: this.$route.params.id,
      blog:{},
      authors:["Henry",'Bucky','Mike'],
      submitted: false
    }
  },
  methods: {
    fetchData(){
      console.log(this)
       this.$http.get("https://floralblog-c0454-default-rtdb.firebaseio.com/posts/"
        + this.id + ".json")
        .then(response=>{
          this.blog = response.body
        })
    },
    post: function(){
      // ajax能做的事情用vue-resource做
      this.$http.put("https://floralblog-c0454-default-rtdb.firebaseio.com/posts/"
        + this.id + ".json").then(function(data){
        this.submitted = true;
      });
    }
  },
  create(){
    console.log(1);
    this.fetchData();
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#add-blog *{
  box-sizing: border-box;
}
#add-blog{
  margin: 20px auto;
  max-width: 600px;
  padding: 20px;
}
label{
  display: block;
  margin: 20px 0 10px;
}
input[type='text'],textarea,select{
  display: block;
  width: 100%;
  padding: 8px;
}
textarea{
  height: 200px;
}
#checkboxes label{
  display: inline-block;
  margin-top: 0;
}
#checkboxes input{
  display: inline-block;
  margin-right: 10px;
}
button{
  display: block;
  margin:20px;
  background-color: crimson;
  color: #fff;
  border: 0;
  padding: 14px;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;
}
#preview{
  padding: 10px 20px;
  border:1px dotted #ccc;
  margin:30px 0;
}
h3{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditBlog.vue